"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteKpi = void 0;
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const react_1 = require("react");
const React = require("react");
require("./site-kpi.less");
class SiteKpi extends react_1.Component {
    render() {
        const { siteKpi = {
            approved: 0,
            city: "",
            dispensed: 0,
            name: "",
            npi: "",
            phone: "",
            state: ""
        } } = this.props;
        return (React.createElement("div", { className: "site-kpi" },
            React.createElement(kpi_title_1.KpiTitle, { label: siteKpi.name, subLabel: `NPI: ${siteKpi.npi} | ${siteKpi.city}, ${siteKpi.state}`, subLabel2: siteKpi.phone })));
    }
}
exports.SiteKpi = SiteKpi;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/site-kpi/site-kpi.tsx
// module id = 4006
// module chunks = 0